<template>
  <div class="my_topic">
    <div class="container-fluid">
      <!-- Begin page -->
      <div class="wrapper">
        <div class="content-page">
          <div class="content">
            <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <Breadcrumb />
                  </div>
                  <h3 class="header-title mb-3" @click="ooooo">负责的课题</h3>
                </div>
                <!-- end page-title-box -->
              </div>
              <!-- end col-->
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="topic_list" v-if="topicList.length">
                      <div class="topic_item" v-for="item in topicList" :key="item.id">
                        <div class="item_title">
                          <div class="topic_title_wrap">
                            <div>
                              <i class="el-icon-menu"></i>
                              <span class="topic_level">【{{item.projectLevelName}}】</span>
                            </div>
                            <el-tooltip class="item" effect="dark" :content="item.declareName" placement="top">
                              <div class="topic_title">{{ item.declareName }}</div>
                            </el-tooltip>
                            <span class="topic_time_range">（{{ getTimeRange(item.projectTime, item.expectedClosingTime) }}）</span>
                          </div>

                          <span class="topic_project_number">立项编号：{{ item.projectNumber }}</span>
                          <span class="learning_stages">学段：{{ item.learningTypeName }}</span>
                          <span class="topic_discipline">学科：{{ item.disciplineName }}</span>
                          <span class="topic_cate">类别：{{ item.projectTypeName }}</span>
                        </div>
                        <div class="item_body">
                          <!-- 课题流程 -->
                          <div class="topic_progress_wrap">
                            <TopicProgress class="progress_custom" :status="item.status" @uploadReport="uploadReport(item, $event)" @viewOpinion="viewOpinion(item.id, $event)" />
                            <el-button type="text" @click="goProcessMaterialListPage(item)">上传过程材料</el-button>
                            <el-button type="text" @click="goTopicChangeApplication(item)">课题变更申请</el-button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- 无数据处理 -->
                    <div class="no_data" v-else>暂无数据</div>
                  </div>
                  <!-- end card-body-->
                </div>
                <!-- end card -->
              </div>
              <!-- end col-->
            </div>
          </div>
        </div>
      </div>
      <!-- end wrapper-->
    </div>

    <!-- 上传报告窗口 -->
    <el-dialog :title="uploadReportDialogTitle" :visible.sync="uploadReportDialogVisible" width="50%" :before-close="handleClose">
      <el-form :model="uploadReportForm" :rules="uploadReportRules" ref="uploadReportFormRef" label-width="100px" class="demo-uploadReportForm">
        <el-form-item label="报告附件" prop="annexObj">
          <UploadFile @file-event="changeData('annexObj', $event)" :value="uploadReportForm.annexObj" :isDisabled="!isShowCurOperateBtn" />
        </el-form-item>
        <el-form-item label="报告名称" prop="reportName">
          <el-input :disabled='!isShowCurOperateBtn' v-model="uploadReportForm.reportName"></el-input>
        </el-form-item>
        <el-form-item label="相关材料" prop="name">
          <UploadFileMore @file-event="changeData1('materials', $event)" :filelist="uploadReportForm.materials" :isDisabled="!isShowCurOperateBtn" />
        </el-form-item>
        <el-form-item label="课题核心成员" prop="coreMemberNameArr" v-if="curOperateTopicPhase === 3">
          <el-tag :key="tag" v-for="tag in uploadReportForm.coreMemberNameArr" closable :disable-transitions="false" @close="removeMember(tag)">{{ tag }}</el-tag>
          <el-input class="input-new-tag" v-if="memberInputVisible" v-model="memberInputValue" ref="saveTagInput" size="small" @keyup.enter.native="memberHandleInputConfirm" @blur="memberHandleInputConfirm"></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showMemberInput">+ New Tag</el-button>
        </el-form-item>
        <el-form-item label="课题核心成员" prop="coreMemberNameArr" v-if="curOperateTopicPhase === 2">
          <div class="coreMemberNameleft"  v-for="(item, index) in tt" :key="index+100">
            <label>姓名:</label> <el-input v-model="input[item+index]" class="coreName" maxlength="4" style="width:100px;!important" ></el-input><label>单位:</label><el-input v-model="input[item+item]"  class=" unitName" maxlength="20" style="width: 240px;"></el-input>
          </div>
          <div class="coreMemberNameright"  v-for="(item, index) in tt" :key="index+50">
            <label>姓名:</label> <el-input v-model="input2[item+index]" class="coreName" maxlength="4" style="width:100px;!important" ></el-input><label>单位:</label><el-input v-model.number="input2[item+item]" class=" unitName" maxlength="20" style="width: 240px;"></el-input>
        </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer" v-if="isShowCurOperateBtn">
        <!-- <span slot="footer" class="dialog-footer"> -->
        <el-button @click="uploadReportDialogVisible = false">关 闭</el-button>
        <el-button type="primary" :loading='updateLoading' @click="commitUploadReport">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 当前意见对话框 -->
    <el-dialog :title="opinionDialogTitle" :visible.sync="opinionDialogVisible" width="60%" :before-close="handleClose">
      <div class="comments-list" v-if="opinionList.length">
        <div class="form-group row mb-2" v-for="(item, index) in opinionList" :key="item.id">
          <label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{ item.auditType == 1 ? '区级审核' + (index + 1) : '学校审核' + (index + 1) }}</label>
          <div class="col-md-9 col-10">
            <table class="table table-bordered table-centered mb-0">
              <tbody>
                <tr>
                  <th>审核意见</th>
                  <td>{{ item.auditState ? '通过' : '不通过' }}</td>
                  <th>审核人</th>
                  <td>{{ item.auditName }}</td>
                  <th>审核时间</th>
                  <td>{{ item.createTime | getTime }}</td>
                </tr>
                <tr>
                  <th>审核说明</th>
                  <td colspan="5">{{ item.auditExplain }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-1 col-2"><span class="required"></span></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="opinionDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import TopicProgress from './components/TopicProgress';
import UploadFile from '@/components/upLoad/UploadFile.vue';
import UploadFileMore from '@/components/upLoad/UploadFileMore.vue';
import UpLoadImgOne from '@/components/upLoad/UpLoadImgOne.vue';
import { getTopicListByUser, uploadOrEditReport, viewReportBystatusAndId, getOpinionByPhaseIdAndAuditType } from '@/api/after/topicManage.js';
export default {
  components: {
    Breadcrumb,
    TopicProgress,
    UploadFile,
    UploadFileMore,
    UpLoadImgOne
  },
  data() {
    return {
      tt:6,
      input:[],
      input2:[],
      opinionDialogTitle: '', //意见对话框标题
      opinionDialogVisible: false,
      opinionList: [], //意见列表
      uploadReportDialogTitle: '提交XX报告', //上传报告对话框标题
      topicListQuery: {
        //课题列表参数
        pageNumber: 1,
        pageSize: 5
      },
      // 课题列表
      topicList: [],
      topicListTotal: 0,
      uploadReportDialogVisible: false,
      uploadReportForm: {
        projectManagementId: '', //课题管理id
        annex: '', //附件id
        annexName: '', //附件名称
        annexObj: { id: '', name: '' },
        reportName: '', //报告名称
        materials: [], //材料
        material: '', //相关材料id多个用逗号隔开
        materialName: '', //相关材料名称多个用逗号隔开
        coreMember: '', //核心组成员
        coreMemberName: '', //核心组成员姓名
        coreMemberNameArr: [],//核心组成员
        status: '' //状态(0:开题,1:中期,2:结题申请,3:结题)
      },
      // dynamicTags: ['标签一', '标签二', '标签三'],
      memberInputVisible: false,
      memberInputValue: '',
      uploadReportRules: {
        annexObj: [{ required: true, message: '请上传报告附件！', trigger: 'change' }],
        // name: [{ required: true, message: '请输入报告名称', trigger: 'blur' }]
      },
      materialsTableData: [], //材料表格数据
      requestTableData: [], //请求表格数据
      tableStyle: {
        backgroundColor: '#4da7dc',
        color: '#fff'
      },
      curOperateTopicId: 0, //当前操作的课题ID
      curOperateTopicPhase: '', //当前操作的课题阶段
      isShowCurOperateBtn: true,//是否显示当前报告弹出框的按钮
      doingEchoData: false,//是否正在回显数据
      updateLoading:false,//上传加载中
    };
  },
  computed: {
    getTimeRange(val1, val2) {
      return (val1, val2) => {
        if (val1) {
          return val1.slice(0, 7) + ' ~ ' + val2.slice(0, 7);
        }
      };
    }
  },
  created() {
    this.getTopicListByUser();
  },
  methods: {
    ooooo(){
window.location.href="http://localhost:8081/#/"
    },
    removeMember(tag) {
      this.uploadReportForm.coreMemberNameArr.splice(this.uploadReportForm.coreMemberNameArr.indexOf(tag), 1);
    },

    showMemberInput() {
      this.memberInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    memberHandleInputConfirm() {
      let memberInputValue = this.memberInputValue;
      console.log('表单数据', this.uploadReportForm);
      if (memberInputValue) {
        this.uploadReportForm.coreMemberNameArr.push(memberInputValue);
      }
      this.memberInputVisible = false;
      this.memberInputValue = '';
    },
    // 跳转到过程材料列表页面
    goProcessMaterialListPage(data) {
      let query = {
        data: encodeURIComponent(JSON.stringify(data))
      };
      this.$router.push({ path: '/backstage/processMaterialList', query });
    },
    // 跳转到课题变更申请页面
    goTopicChangeApplication(data) {
      let query = {
        data: encodeURIComponent(JSON.stringify(data))
      };
      this.$router.push({ path: '/backstage/topicChangeApplication', query });
    },
    // 根据ID和阶段获取报告
    async viewReportBystatusAndId(params) {
      const res = await viewReportBystatusAndId(params);
      if (res.code == 200) {
        console.log('当前报告', res);
        let data = JSON.parse(JSON.stringify(res.data))
        if (data) {
          data.annexObj = { id: data.annex, name: data.annexName };
          // 处理相关材料数据
          if (data.material) {
            let idArr = data.material.split(',');
            let nameArr = data.materialName.split(',');
            data.materials = [];
            idArr.forEach((item, index) => {
              data.materials.push({
                id: item,
                name: nameArr[index]
              });
            });
          } else {
            data.materials = [];
          }
          // 处理核心成员数据
          if (data.coreMemberName) {
            data.coreMemberNameArr = data.coreMemberName.split(',')
          } else {
            data.coreMemberNameArr = []
          }
          console.log('回显处理的数据', data);
          this.uploadReportForm = data;
          this.doingEchoData = true;//正在回显数据
        } else {
          this.resetUploadReportForm();
        }
      } else {
        this.$message.error(res.data);
      }
    },
    // 重置表单
    resetUploadReportForm() {
      this.uploadReportForm = {
        projectManagementId: '', //课题管理id
        annex: '', //附件id
        annexName: '', //附件名称
        annexObj: { id: '', name: '' },
        reportName: '', //报告名称
        materials: [], //材料
        material: '', //相关材料id多个用逗号隔开
        materialName: '', //相关材料名称多个用逗号隔开
        coreMember: '', //核心组成员
        coreMemberName: '', //核心组成员姓名
        coreMemberNameArr: [],//核心组成员
        status: '' //状态(0:开题,1:中期,2:结题申请,3:结题)
      };
    },
    // 提交上传报告,用于上传或者修改报告
    commitUploadReport() {
      if (!this.uploadReportForm.annexObj.id) {
        return this.$message.error('请上传报告附件！')
      }
      if(this.updateLoading)return;
      this.updateLoading=true;
      this.uploadReportForm.projectManagementId = this.curOperateTopicId;
      this.uploadReportForm.status = this.curOperateTopicPhase;
      // 处理相关材料数据
      if (this.uploadReportForm.materials.length) {
        let arr = this.uploadReportForm.materials;
        this.uploadReportForm.material = arr
          .map(item => {
            return item.id;
          })
          .join(',');
        this.uploadReportForm.materialName = arr
          .map(item => {
            return item.name;
          })
          .join(',');
      }
      //处理核心成员数据
      if (this.uploadReportForm.coreMemberNameArr.length) {
        this.uploadReportForm.coreMemberName = this.uploadReportForm.coreMemberNameArr.join(',')
      } else {
        this.uploadReportForm.coreMemberName = ''
      }
      console.log('处理上传报告数据', this.uploadReportForm);
      this.uploadOrEditReport();
    },
    
    // 上传或者编辑报告
    async uploadOrEditReport() {
      const res = await uploadOrEditReport(this.uploadReportForm);
      if (res.code == 200) {
        this.$message.success('上传报告成功！');
        this.getTopicListByUser();
        this.uploadReportDialogVisible = false;
       setTimeout(()=>{
         this.updateLoading=false;
       },500)
      } else {
        this.$message.error(res.data);
      }
    },
    // 获取意见通过阶段ID和审核类型
    async getOpinionByPhaseIdAndAuditType(params) {
      const res = await getOpinionByPhaseIdAndAuditType(params);
      if (res.code == 200) {
        if (res.data) {
          console.log('意见列表', res);
          this.opinionList = res.data;
        }
      } else {
        this.$message.error(res.data);
      }
    },
    // 课题列表切换每页大小
    topicSizeChange(val) {
      this.topicListQuery.pageSize = val;
      this.getTopicListByUser();
    },
    // 课题列表翻页
    topicCurrentChange(val) {
      this.topicListQuery.pageNumber = val;
      this.getTopicListByUser();
    },
    // 根据当前登录人获取负责的课题列表
    async getTopicListByUser() {
      const res = await getTopicListByUser(this.topicListQuery);
      if (res.code == 200) {
        console.log('负责的课题列表', res);
        this.topicList = res.data.records;
        this.topicListTotal = res.data.total;
      } else {
        this.$message.error(res.data);
      }
    },
    //材料多选
    materialsSelectionChange(val) { },
    //课题变更请求多选
    requestSelectionChange(val) { },
    // 上传报告
    uploadReport(item, index) {
      console.log(item.id, index);
      // 获取点击上传按钮的阶段
      let status = this.getUploadReportPhaseByIndex(index);
      // 修改当前操作课题ID
      this.curOperateTopicId = item.id;
      // 获取当前操作课题阶段
      this.curOperateTopicPhase = status;
      // 控制上传报告对话框按钮的显示和隐藏
      this.controlUploadDialogBtnShow(item.status, status);
      // 判断获取上传报告对话框标题
      switch (status) {
        case 0:
          this.uploadReportDialogTitle = '上传开题报告';
          break;
        case 1:
          this.uploadReportDialogTitle = '上传中期报告';
          break;
        // case 2:
        //   this.uploadReportDialogTitle = '上传结题申请报告';
        //   break;
        case 2:
          this.uploadReportDialogTitle = '上传结题报告';
          break;
        default:
          break;
      }
      this.uploadReportDialogVisible = true;
      let params = { status, id: item.id };
      this.viewReportBystatusAndId(params);
    },
    // 通过索引判断当前上传报告处于哪个阶段
    getUploadReportPhaseByIndex(index) {
      switch (index) {
        case 0:
          return 0;
          break;
        case 3:
          return 1;
          break;
        case 6:
          return 2;
          break;
        // case 9:
        //   return 3;
        //   break;
        default:
          return '错误的索引值';
      }
    },
    // 控制上传报告对话框按钮的显示隐藏
    controlUploadDialogBtnShow(status, phase) {
      switch (phase) {
        case 0:
          if ([0, 1, 2, 4].includes(status)) {
            this.isShowCurOperateBtn = true;
          } else {
            this.isShowCurOperateBtn = false;
          }
          break;
        case 1:
          if ([5, 6, 7, 9].includes(status)) {
            this.isShowCurOperateBtn = true;
          } else {
            this.isShowCurOperateBtn = false;
          }
          break;
        // case 2:
        //   if ([10, 11, 12, 14].includes(status)) {
        //     this.isShowCurOperateBtn = true;
        //   } else {
        //     this.isShowCurOperateBtn = false;
        //   }
        //   break;
        case 2:
          if ([15, 16, 17, 19].includes(status)) {
            this.isShowCurOperateBtn = true;
          } else {
            this.isShowCurOperateBtn = false;
          }
          break;
        default:
          break;
      }
    },
    // 查看意见
    viewOpinion(id, index) {
      this.opinionDialogVisible = true;
      let obj = this.getOpinionPhaseByIndex(index);
      let params = {
        projectManagementId: id,
        ...obj
      };
      // console.log('要传递的参数',params);
      this.getOpinionByPhaseIdAndAuditType(params);
    },
    // 通过索引判断当前意见处于哪个阶段
    getOpinionPhaseByIndex(index) {
      switch (index) {
        case 1:
          return {
            type: 0,
            auditType: 0
          };
          break;
        case 2:
          return {
            type: 0,
            auditType: 1
          };
          break;
        case 4:
          return {
            type: 1,
            auditType: 0
          };
          break;
        case 5:
          return {
            type: 1,
            auditType: 1
          };
          break;
        case 7:
          return {
            type: 3,
            auditType: 0
          };
          break;
        case 8:
          return {
            type: 3,
            auditType: 1
          };
          break;
        // case 10:
        //   return {
        //     type: 3,
        //     auditType: 0
        //   };
        //   break;
        // case 11:
        //   return {
        //     type: 3,
        //     auditType: 1
        //   };
        //   break;
        default:
          return '错误的索引值';
      }
    },
    // 附件数据
    changeData(name, data) {
      this.uploadReportForm[name] = data;
      this.uploadReportForm.annex = data.id;
      this.uploadReportForm.annexName = data.name;
      if (!this.doingEchoData) {
        this.uploadReportForm.reportName = data.name.slice(0, data.name.indexOf('.'));
      } else {
        this.doingEchoData = false
      }
    },
    // 相关材料数据
    changeData1(name, data) {
      this.uploadReportForm[name] = data;
    },
    // 关闭上传报告对话框
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.no_data {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.topic_progress_wrap {
  display: flex;
  align-items: center;
}
.progress_custom {
  flex: 1;
}
.topic_item {
  margin-bottom: 20px;
}
.item_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  height: 50px;
  .topic_level {
    font-weight: bolder;
  }
  .topic_title {
    font-size: 16px;
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .topic_title_wrap {
    display: flex;
    align-items: center;
  }
}

.process_materials_title,
.change_request_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}
.btn_wrap {
  margin-top: 10px;
}
.custom_table {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #d0e4f5;
  color: #2d87bd;
}
.upload_change_topic_info_form {
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  ::v-deep .el-row {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border: 1px solid #dfedfc;
  }
  ::v-deep .el-row:first-child {
    padding: 0 !important;
  }
  .form_item_title {
    display: inline-block;
    width: 130px;
    padding-right: 10px;
    text-align: right;
  }
  .tip {
    color: red;
  }
}
.coreMemberNameleft{
float: left; 
 margin-bottom: 5px;
  
}
.coreMemberNameright{
  float: right;
  margin-bottom: 5px;
}
</style>
